module.exports = __webpack_public_path__ + "img/adulto35.0ffa47bc.jpg";